var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('el-container',[_c('Menu'),_vm._v(" "),_c('el-container',{staticClass:"content"},[_c('Header'),_vm._v(" "),_c('el-main',[_c('Breadcrumb'),_vm._v(" "),_c('div',{staticClass:"cont"},[_c('router-view')],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709a741a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/layout.vue
// module id = null
// module chunks = 